// src/modules/competitions/components/CompetitionDetails.tsx - VERSIÓN COMPLETA

import React, { useState } from 'react';
import Card from '../../../shared/components/ui/Card';
import {
  CompetitionDetails as CompetitionDetailsType,
  MyCategoryParticipation
} from '../types';
import { competitionService } from '../services/competitionService';
import Button from '../../../shared/components/ui/Button';
import '../styles/competitionDetails.css'; // El que corresponda
import { useNavigate } from 'react-router-dom';
import { getFullImageUrl } from '../../../shared/services/apiConfig';

interface CompetitionDetailsProps {
  details: CompetitionDetailsType;
  onRegister?: () => void;
  showRegisterButton?: boolean;
  onRegisterInCategory?: (categoryId: number, level?: string | null) => void; // ✅ Agregar level
  myCategories?: MyCategoryParticipation[];
}


const CompetitionDetails: React.FC<CompetitionDetailsProps> = ({
  details,
  onRegister,
  showRegisterButton = false,
  onRegisterInCategory,
  myCategories = []
}) => {
  const navigate = useNavigate();
  const { competition, categories, my_categories } = details;
  console.log("details", details)
  console.log("myCategories", myCategories)
  console.log("categories", categories)
  const [showLevelModal, setShowLevelModal] = useState(false);
  const [selectedLevel, setSelectedLevel] = useState<{
    categoryId: number;
    categoryName: string;
    level: string | null;
  } | null>(null);




  const hasPromotionalImage = (competition: any): boolean => {
    return !!competition.promotional_image_filename;
  };

  const handleViewCategoryImages = (
    categoryId: number,
    categoryName: string,
    level: string,
    participantId: number
  ) => {
    navigate(`/competitions/category/${categoryId}/images`, {
      state: {
        categoryName,
        level,
        participantId,
        competitionId: competition.id,
      }
    });
  };

  const handleLevelSelection = (categoryId: number, categoryName: string, level: string | null) => {
    setSelectedLevel({ categoryId, categoryName, level });
    setShowLevelModal(true);
  };

  const handleConfirmRegistration = () => {
    if (selectedLevel && onRegisterInCategory) {
      onRegisterInCategory(selectedLevel.categoryId, selectedLevel.level);
    }
    setShowLevelModal(false);
    setSelectedLevel(null);
  };

  const handleCancelRegistration = () => {
    setShowLevelModal(false);
    setSelectedLevel(null);
  };

  const formatCurrency = (amount: number, currency: string) => {
    return new Intl.NumberFormat('es-CL', {
      style: 'currency',
      currency: currency
    }).format(amount);
  };

  const formatDate = (dateString: string) => {
    return competitionService.formatDate(dateString);
  };

  const registrationStatus = competitionService.isRegistrationOpen(competition);
  console.log("registrationStatus", registrationStatus)
  const renderCompetitionInfo = () => (
    <Card className="competition-info-card" variant="elevated">
      <div className="competition-header">
        {competition.image_url && (
          <img
            src={getFullImageUrl(competition.image_url) ?? undefined}
            alt={competition.title}
            className="competition-banner"
          />
        )}

        <div className="competition-meta">
          <div className="competition-title-row">
            {/* Avatar circular con imagen promocional */}
            {hasPromotionalImage(competition) ? (
              <img
                src={getFullImageUrl(competition.image_url) ?? undefined}
                alt={competition.title}
                className="competition-avatar"
                onError={(e) => {
                  e.currentTarget.style.display = 'none';
                }}
              />
            ) : (
              <div className="competition-avatar-placeholder">
                🏆
              </div>
            )}

            <div className="title-content">
              {competition.category_name && (
                <div
                  className="competition-category-badge"
                  style={{ backgroundColor: competition.category_color }}
                >
                  {competition.category_icon} {competition.category_name}
                </div>
              )}

              <h1 className="competition-title">{competition.title}</h1>
            </div>
          </div>

          <div className="competition-organizer">
            Organizado por: {competition.created_by_name || 'iBloom Academy'}
          </div>
        </div>
      </div>

      <div className="competition-content">
        <p className="competition-description">{competition.description}</p>

        <div className="competition-details-grid">
          <div className="detail-item">
            <h4>Fechas del evento</h4>
            <p>📅 Inicio: {formatDate(competition.start_date)}</p>
            <p>📅 Fin: {formatDate(competition.end_date)}</p>
          </div>

          {competition.registration_start && competition.registration_end && (
            <div className="detail-item">
              <h4>Periodo de inscripción</h4>
              <p>📝 Abre: {formatDate(competition.registration_start)}</p>
              <p>📝 Cierra: {formatDate(competition.registration_end)}</p>
            </div>
          )}

          <div className="detail-item">
            <h4>Ubicación</h4>
            <p>📍 {competition.location || 'Por definir'}</p>
            {competition.venue && <p>🏢 {competition.venue}</p>}
          </div>

          <div className="detail-item">
            <h4>Participación</h4>
            <p>👥 Nivel: {competition.level}</p>
            {competition.max_participants && (
              <p>🎯 Máximo: {competition.max_participants} participantes</p>
            )}
          </div>

          {competition.prize_pool && (
            <div className="detail-item">
              <h4>Premios</h4>
              <p>🏆 {formatCurrency(competition.prize_pool, competition.currency)}</p>
            </div>
          )}
        </div>
      </div>
    </Card>
  );

  const renderCategories = () => {
  const myCats = details.my_categories || [];
  
  return (
    <Card className="categories-card" variant="elevated">
      <h2>Categorías de Competencia</h2>

      {myCats.length === 0 ? (
        <p>No hay categorías disponibles aún.</p>
      ) : (
        <div className="categories-grid">
          {myCats.map((myCategory) => {
            // Si está aprobado y tiene level, muestra botón "Ver Imágenes"
            const showViewButton = myCategory.approval_status === 'approved' && myCategory.level;
            
            // Si está aprobado pero NO tiene level, muestra botones de niveles
            const showLevelButtons = myCategory.approval_status === 'approved' && !myCategory.level && myCategory.available_levels;

            return (
              <div
                key={myCategory.category_id}
                className="category-card-image"
              >
                {/* Imagen de fondo */}
                {myCategory.image_url ? (
                  <img
                    src={getFullImageUrl(myCategory.image_url) ?? undefined}
                    alt={myCategory.category_name}
                    className="category-bg-image"
                  />
                ) : (
                  <div
                    className="category-bg-image"
                    style={{
                      background: 'linear-gradient(135deg, var(--primary-color) 0%, var(--secondary-color) 100%)'
                    }}
                  />
                )}

                <div className="category-overlay-dark"></div>

                {/* Badges de estado */}
                <div className={`category-status-badge status-${myCategory.approval_status}`}>
                  {competitionService.getApprovalStatusText(myCategory.approval_status)}
                </div>
                {myCategory.participant_number && (
                  <div className="category-participant-badge">
                    N° {myCategory.participant_number}
                  </div>
                )}

                <div className="category-card-content">
                  <div className="category-card-header">
                    <h3 className="category-card-title">{myCategory.category_name}</h3>
                    {myCategory.category_description && (
                      <div className="category-card-description">
                        {myCategory.category_description}
                      </div>
                    )}
                  </div>

                  <div className="category-card-footer">
                    <div className="category-card-info">
                      {myCategory.max_participants && (
                        <div className="category-info-item">
                          <span>👥</span>
                          <span>Máx. {myCategory.max_participants}</span>
                        </div>
                      )}
                    </div>

                    <div className="category-prices-section">
                      {myCategory.entry_fee > 0 && (
                        <div className="category-price-section">
                          <span className="category-price-label">INSCRIPCIÓN</span>
                          <span className="category-price-value">
                            {formatCurrency(myCategory.entry_fee, competition.currency)}
                          </span>
                        </div>
                      )}
                    </div>

                    {/* Botón Ver Imágenes (si tiene level asignado) */}
                    {showViewButton && (
                      <button
                        className="btn-view-images"
                        onClick={() => handleViewCategoryImages(
                          myCategory.category_id,
                          myCategory.category_name,
                          myCategory.level!,
                          myCategory.participant_id
                        )}
                      >
                        VER IMÁGENES →
                      </button>
                    )}

                    {/* Botones de Niveles (si NO tiene level asignado) */}
                    {showLevelButtons && (
                      <div className="category-levels-section">
                        <span className="category-levels-label">Selecciona tu nivel:</span>
                        <div className="category-levels-buttons">
                          {myCategory.available_levels!.map((level) => (
                            <button
                              key={level}
                              className="btn-category-level"
                              onClick={() => handleLevelSelection(myCategory.category_id, myCategory.category_name, level)}
                            >
                              {level}
                            </button>
                          ))}
                        </div>
                      </div>
                    )}

                    {/* Mensaje de rechazo */}
                    {myCategory.rejection_reason && (
                      <div className="category-rejection-message">
                        <p>
                          <span>⚠️</span>
                          <span>{myCategory.rejection_reason}</span>
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </Card>
  );
};



  return (
    <div className="competition-details">
      {renderCompetitionInfo()}

      {/* Botón de registro general */}
      {showRegisterButton && onRegister && (
        <div className="register-section">
          <Card variant="elevated" padding="large">
            <h3>Inscripción en Competencia</h3>
            <p>
              Para participar en esta competencia, primero debes registrarte
              y aceptar los términos y condiciones. Una vez aprobado tu registro,
              podrás inscribirte en las categorías disponibles.
            </p>
            <Button className="primary" size="lg" onClick={onRegister}>
              Inscribirse en esta Competencia
            </Button>
          </Card>
        </div>
      )}

      {renderCategories()}
      {showLevelModal && selectedLevel && (
        <div className="modal-overlay" onClick={handleCancelRegistration}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h3>Confirmar Inscripción</h3>
            <p>
              ¿Deseas inscribirte en la categoría <strong>{selectedLevel.categoryName}</strong>
              {selectedLevel.level && (
                <> en el nivel <strong>{selectedLevel.level}</strong></>
              )}?
            </p>
            <div className="modal-actions">
              <Button className="btn-outline" onClick={handleCancelRegistration}>
                Cancelar
              </Button>
              <Button className="btn-primary" onClick={handleConfirmRegistration}>
                Confirmar Inscripción
              </Button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default CompetitionDetails;